/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import Close_Icon from "../icons/Close_Icon";
import "../../components/styled/style-itemTravel.css";
import TableTravels from "./TableTravels";
import Download_Icon_File_Icon from "../icons/Download_File_Icon";
import Send_Icon_File from "../icons/Send_Icon_File";
import download_status_account_DRIVERS from "../../hooks/pdfSendDriver/downloadStatusAccount";
import SpinnerLoading from "../SpinnerLoading/SpinnerLoading";
import RegisterToCollectionFinance from "../../hooks/RegisterToCollectionFinance/RegisterToCollectionFinance";
import SendStatusAccountDrivers from "../../hooks/pdfSendDriver/sendStatusAccount";
import Calculate_status_coms_drivers from "../../hooks/Calculata_status_coms_drivers/Calculate_status_coms_drivers";
import createPDF from "../../hooks/CreatePDF/createPDF";
import { useUserStore } from "../../stores";
/* import { register_order } from "../../hooks/STP_Operations/register_order"; */
import { Generate_Excel_Drivers } from "../../hooks/Generate_excel_drivers/generate_excel_driver";
import MenuOptionsDriver from "./MenuOptions";
import OptionsTooltip from "./OptionsTooltip";
import InfoToolTip from "./InfoTooltip";
import { Calculate_status_coms_driver_excel } from "../../hooks/Calculate_status_coms_driver_excel/Calculate_status_coms_driver_excel";
import ClaerFilter_Icon from "../icons/ClearFilter_Icon";
import Snackbar from "../SnackBar/Snackbar";

import styled from "styled-components";

const BlurredModal = styled.div`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 999;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  top: 0;
  left: 0;
  min-height: 100vh;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(8px);
    z-index: -1;
  }
`;

export default function ModalTravels({
  ObjectDriver,
  openTravels,
  closeTravels,
}) {
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const [isStatusFiles, setIsStatusFiles] = useState("");
  const currentUser = useUserStore((state) => state.currentUser);
  const { send_status_account_DRIVERS } = SendStatusAccountDrivers();
  const [Travels, setTravels] = useState(ObjectDriver.travel_matches);
  const [bodyExcel, setBodyExcel] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [addDocument] = RegisterToCollectionFinance(
    "project_CMS/Exports/StatementsDrivers"
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  async function send_status_account() {
    try {
      const response_calculate = await Calculate_status_coms_drivers(Travels);
      const structure_object_send = {
        email: "alejandro.g.g.developer@gmail.com",
        nameOfDriver: ObjectDriver.conductorName || "",
        phoneNumber: ObjectDriver.conductorTelefono || "",
        isDebt: response_calculate.isDebt,
        movementData: response_calculate.movementData,
        totalGain: response_calculate.totalGain,
        netAmount: response_calculate.netAmount,
        iva: response_calculate.iva,
        isr: response_calculate.isr,
        platformFees: response_calculate.platformFees,
        totalCommission: response_calculate.totalCommission,
        balanceTotalAmount: response_calculate.balanceTotalAmount,
        applicationFee: response_calculate.applicationFee,
      };

      await send_status_account_DRIVERS(structure_object_send);
      setIsStatusFiles("Estado de cuenta enviado correctamente");
      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
      }, 5000);
    } catch (err) {
      setIsStatusFiles("Error al enviar estado de cuenta al conductor");
      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
      }, 5000);
    }
  }

  async function download_status_account() {
    const response_calculate = await Calculate_status_coms_drivers(Travels);

    const structure_object_send = {
      email: ObjectDriver.conductorCorreo,
      nameOfDriver: ObjectDriver.conductorName || "",
      phoneNumber: ObjectDriver.conductorTelefono || "",
      isDebt: response_calculate.isDebt,
      movementData: response_calculate.movementData,
      totalGain: response_calculate.totalGain,
      netAmount: response_calculate.netAmount,
      iva: response_calculate.iva,
      isr: response_calculate.isr,
      platformFees: response_calculate.platformFees,
      totalCommission: response_calculate.totalCommission,
      balanceTotalAmount: response_calculate.balanceTotalAmount,
      applicationFee: response_calculate.applicationFee,
    };

    const download_status_account = await download_status_account_DRIVERS(
      structure_object_send
    );

    let name_doc = `comisiones_viaje_${
      ObjectDriver.conductorName.replace(/\s+/g, "") +
        "_" +
        new Date().toISOString() || ""
    }.pdf`;

    createPDF(name_doc, download_status_account);

    const save_log = {
      timestamp: new Date().toISOString(),
      by: currentUser.username,
      details: {
        email: ObjectDriver.conductorCorreo,
        nameOfDriver: ObjectDriver.conductorName || "",
        phoneNumber: ObjectDriver.conductorTelefono || "",
        isDebt: structure_object_send.isDebt,
        totalGain: structure_object_send.totalGain,
        netAmount: structure_object_send.netAmount,
        iva: structure_object_send.iva,
        isr: structure_object_send.isr,
        platformFees: structure_object_send.platformFees,
        totalCommission: structure_object_send.totalCommission,
        balanceTotalAmount: structure_object_send.balanceTotalAmount,
        applicationFee: structure_object_send.applicationFee,
      },
      name_document: name_doc,
      period: "Semanal",
    };

    await addDocument(save_log);

    setIsStatusFiles("Archivo pdf descargado correctamente");
    setShowSnackbar(true);
    setTimeout(() => {
      setShowSnackbar(false);
    }, 5000);
  }

  async function FilterTravels() {
    if (startDate && endDate) {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      let newtravels = ObjectDriver.travel_matches.filter((viaje) => {
        const fechasolicitud = new Date(viaje?.time_request);
        return fechasolicitud >= startDate && fechasolicitud <= endDate;
      });
      setTravels(newtravels);
    }
  }

  useEffect(() => {
    if (
      dateRange[0].toISOString().substring(0, 10) !==
      new Date().toISOString().substring(0, 10)
    ) {
      FilterTravels();
    }
  }, [dateRange]);

  /*   useEffect(() => {
    const array_rows = Calculate_status_coms_driver_excel(Travels);
    setBodyExcel(array_rows);
  }, [Travels]);
 */
  async function cleanFilter() {
    setTravels(ObjectDriver.travel_matches);
    setDateRange([new Date(), new Date()]);
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <BlurredModal open={openTravels}>
      <div className="content-dialog">
        <div className="header-dialog">
          <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
            <OptionsTooltip />
            <InfoToolTip
              content={`Nombre:${
                ObjectDriver.driver_info.name +
                " " +
                ObjectDriver.driver_info.last_name
              }
              Email: ${ObjectDriver.driver_info.email}
              Número: ${ObjectDriver.driver_info.phone}
              Estatus: ${ObjectDriver.driver_info.status}`}
            />
            <div style={{ display: "flex", gap: "15px" }}>
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                setDateRange={setDateRange}
                disabled={false}
                maxDate={new Date()}
                controlWidth={windowWidth}
              />
              {startDate.toISOString().substring(0, 10) !==
              new Date().toISOString().substring(0, 10) ? (
                <button
                  style={{
                    cursor: "pointer",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "#004990",
                  }}
                  onClick={() => cleanFilter()}
                >
                  <ClaerFilter_Icon color={"#ffffff"} />
                </button>
              ) : null}
            </div>

            {/* 
            <MenuOptionsDriver
              showAll={() => setTravels(ObjectDriver.viajes)}
              sendStatusAccount={() => send_status_account()}
              downloadPdf={() => download_status_account()}
              downloadExcel={() =>
                Generate_Excel_Drivers(bodyExcel, ObjectDriver)
              }
            /> */}
          </div>

          <button
            style={{
              backgroundColor: "#004990",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "35px",
              height: "40px",
              borderRadius: "50%",
              cursor: "pointer",
              boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            }}
            onClick={closeTravels}
          >
            <Close_Icon />
          </button>
        </div>

        <div className="content-table">
          {Travels.length > 0 ? (
            <>
              <TableTravels
                Travels={Travels}
                controlWidth={windowWidth}
                dateRange={dateRange}
                ObjectDriver={ObjectDriver}
              />
            </>
          ) : (
            <div>No tiene viajes finalizados</div>
          )}
        </div>
      </div>
      {isStatusFiles !== "" ? (
        <Snackbar showSnackbar={showSnackbar} text={isStatusFiles} />
      ) : null}
    </BlurredModal>
  );
}
